<template>
	<b-modal ref="mdlDataAnalysisDashboardPivotEditModalComponent" :title="title" size="xl" ok-title="Conferma" @ok="onOkConferma" scrollable>
		<div style="height: calc(100vh - 150px)">
			<b-tabs v-model="tabIndex" content-class="mt-3" ref="tabs" class="sa-tab sa-tab-modal" style="height: 100%" act fill @input="onInputTabIndex">
				<b-tab title="Dati" class="sa-tab-content">
					<!-- <div style="display: flex; justify-content: end; padding: 4px">
						<b-button size="sm" variant="outline-success outline-secondary-noborder pull-right" @click="test()"> <i class="fas fa-pencil-alt"></i> Conferma Struttura </b-button>
					</div> -->
					<pivot class="sa-pivot-edit" ref="cmpPivotData" cols-label-text="Trascina i campi qui per le colonne" rows-label-text="Righe" :key="pivotKey" :data="pivotData" v-model="pivotFields" :showSettings="defaultShowSettings" />
				</b-tab>
				<b-tab title="Parametri">
					<div style="display: flex; justify-content: end; padding: 4px">
						<b-button size="sm" variant="outline-success outline-secondary-noborder pull-right" @click="onClickConfermaStruttura()"> <i class="fas fa-pencil-alt"></i> Conferma Struttura </b-button>
					</div>
					<b-row v-for="obj in pivotParams.fieldsParam" class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem" :key="obj.uniqueName">
						<b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
							<b-input v-model="obj.caption"></b-input>
						</b-col>
						<b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
							{{ obj.uniqueName }}
						</b-col>
						<b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
							<b-input v-model="obj.type"></b-input>
						</b-col>
					</b-row>
				</b-tab>
			</b-tabs>
		</div>
	</b-modal>
</template>

<script>
import { Pivot } from "vue-pivot-table-plus";
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { Pivot },
	data() {
		return {
			idQuery: null,
			title: "",
			tabIndex: 0,
			pivotKey: 0,
			pathResourceData: "/dataanalysisdatabaseinfo/eseguianaliticquery",
			fieldsParam: [],
			pivotParams: {
				fieldsParam: [],
				pivotFields: {
					availableFields: [],
					rowFields: [],
					colFields: [],
					fieldsOrder: {},
				},
			},
			reportJson: {
				dataSource: { data: [] },
				slice: {
					rows: [],
					columns: [],
					measures: [],
				},
				localization: "lang/pivottable/it.json",
			},
			pivotData: [],
			pivotFields: {
				availableFields: [],
				rowFields: [],
				colFields: [],
				fieldsOrder: {},
			},
			defaultShowSettings: true,
			resultData: null,
		};
	},
	methods: {
		show(chartParams) {
			let me = this;
			me.idQuery = chartParams.idQuery;
			me.pivotParams = chartParams.pivotParams ? JSON.parse(JSON.stringify(chartParams.pivotParams)) : { fieldsParam: [] };
			me.reportJson.slice = me.pivotParams.slice ? me.pivotParams.slice : { rows: [], columns: [], measures: [] };
			if (!this.pivotParams.pivotFields) {
				this.pivotParams.pivotFields = {
					availableFields: [],
					rowFields: [],
					colFields: [],
					fieldsOrder: {},
				};
			} else {
				this.setPivotParams();
			}

			if (!chartParams.pivotParams) {
				this.tabIndex = 1;
			}
			me.loadData();
		},
		loadData() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceData + "/";
			this.$emit("beforeLoadData");
			axios.get(link + me.idQuery)
				.then((response) => {
					me.resultData = response.data.data;
					me.reportJson.dataSource.data = response.data.data;
					if (me.reportJson.dataSource.data.length > 0) {
						if (me.pivotParams.fieldsParam.length === 0) {
							let record = me.reportJson.dataSource.data[0];
							for (var key of Object.keys(record)) {
								me.pivotParams.fieldsParam.push({ uniqueName: key, caption: key, type: "string" });
							}
						} else {
							//me.reportJson.dataSource.data.unshift(me.getDataConfig());
						}
					}
					this.eleboraDati();
					me.pivotKey++;
					this.$emit("afterLoadData");
					me.$refs.mdlDataAnalysisDashboardPivotEditModalComponent.show();
				})
				.catch((e) => {
					console.log(e);
				});
		},
		onReportComplete() {},
		onClickApplica() {},
		getDataConfig() {
			let me = this;
			let dataConfig = {};
			for (var field of me.pivotParams.fieldsParam) {
				dataConfig[field.uniqueName] = { type: field.type, caption: field.caption };
			}

			return dataConfig;
		},
		applicaconfigurazione() {
			let me = this;
			me.reportJson.dataSource.data.unshift(me.getDataConfig());
			me.pivotKey++;
		},
		onOkConferma() {
			this.pivotParams.pivotFields.availableFields = this.pivotFields.availableFields;
			this.pivotParams.pivotFields.rowFields = this.pivotFields.rowFields;
			this.pivotParams.pivotFields.colFields = this.pivotFields.colFields;
			//this.pivotParams.slice = { rows: [], columns: [], measures: [] }; //this.$refs.cmpPivotData.webdatarocks.getReport().slice;
			this.$emit("updatePivotParams", this.pivotParams);
		},
		onClickConfermaStruttura() {
			this.creaStruttura();
		},
		creaStruttura() {
			let me = this;
			me.pivotFields.availableFields = [];
			me.pivotFields.rowFields = [];
			me.pivotFields.colFields = [];
			me.pivotParams.fieldsParam.forEach((fieldParams) => {
				if (fieldParams.type !== "none") {
					me.pivotFields.availableFields.push({ getter: (item) => item[fieldParams.uniqueName], label: fieldParams.caption, key: fieldParams.uniqueName });
				}
			});
			let dataTimeFields = this.pivotParams.fieldsParam.filter((field) => field.type === "timestamp");
			dataTimeFields.forEach((fieldParam) => {
				let year_key = fieldParam.uniqueName + "_year";
				let year_caption = "Anno (" + fieldParam.caption + ")";
				this.pivotFields.availableFields.push({ getter: (item) => item[year_key], label: year_caption, key: year_key });

				let quarter_key = fieldParam.uniqueName + "_quarter";
				let quarter_caption = "Trimestre (" + fieldParam.caption + ")";
				this.pivotFields.availableFields.push({ getter: (item) => item[quarter_key], label: quarter_caption, key: quarter_key });

				let month_key = fieldParam.uniqueName + "_month";
				let month_caption = "Mese (" + fieldParam.caption + ")";
				this.pivotFields.availableFields.push({ getter: (item) => item[month_key], label: month_caption, key: month_key });

				let day_key = fieldParam.uniqueName + "_day";
				let day_caption = "Giorno (" + fieldParam.caption + ") ";
				this.pivotFields.availableFields.push({ getter: (item) => item[day_key], label: day_caption, key: day_key });

				let day_week_key = fieldParam.uniqueName + "_day_week";
				let day_week_caption = "Giorno Settimana (" + fieldParam.caption + ") ";
				this.pivotFields.availableFields.push({ getter: (item) => item[day_week_key], label: day_week_caption, key: day_week_key });
			});
		},
		setAvailableFields() {
			let me = this;
			me.pivotFields.availableFields = [];
			me.pivotParams.fieldsParam.forEach((fieldParams) => {
				if (fieldParams.type !== "none") {
					me.pivotFields.availableFields.push({ getter: (item) => item[fieldParams.uniqueName], label: fieldParams.caption, key: fieldParams.uniqueName });
				}
			});
		},
		eleboraDati() {
			this.pivotData = [];
			let dataTimeFields = this.pivotParams.fieldsParam.filter((field) => field.type === "timestamp");
			this.resultData.forEach((row) => {
				dataTimeFields.forEach((fieldParam) => {
					let dataOra = new Date(row[fieldParam.uniqueName]);
					let year = dataOra.getFullYear();
					let month = dataOra.getMonth() + 1;
					let dayOfWeek = dataOra.getDay();
					let day = dataOra.getDate();
					var quarter = Math.floor((dataOra.getMonth() + 3) / 3);
					let year_key = fieldParam.uniqueName + "_year";
					row[year_key] = year;
					let month_key = fieldParam.uniqueName + "_month";
					row[month_key] = month;
					let day_key = fieldParam.uniqueName + "_day";
					row[day_key] = day;
					let quarter_key = fieldParam.uniqueName + "_quarter";
					row[quarter_key] = quarter;
					let day_week_key = fieldParam.uniqueName + "_day_week";
					row[day_week_key] = UtilityMixin.methods.getDayOfWeek((dayOfWeek + 1).toString());
				});
				this.pivotData.push(row);
			});
		},
		onInputTabIndex(index) {
			if (index === 0) {
				this.pivotKey++;
			}
		},
		ontest() {
			this.setAvailableFields();
		},
		test() {
			// this.pivotFields.availableFields = this.pivotParams.pivotFields.availableFields;
			// this.pivotFields.rowFields = this.pivotParams.pivotFields.rowFields;
			// this.pivotKey++;
			//console.log(this.$refs.cmpPivotData);
			//Sthis.$refs.cmpPivotData.downloadPivotTableData("csv");
			//console.log(this.$refs.cmpPivotData.getAggregatedData());
		},
		setPivotParams() {
			this.pivotParams.pivotFields.availableFields.forEach((pivotField) => {
				this.pivotFields.availableFields.push({ getter: (item) => item[pivotField.key], label: pivotField.label, key: pivotField.key });
			});
			this.pivotParams.pivotFields.colFields.forEach((pivotField) => {
				this.pivotFields.colFields.push({ getter: (item) => item[pivotField.key], label: pivotField.label, key: pivotField.key });
			});
			this.pivotParams.pivotFields.rowFields.forEach((pivotField) => {
				this.pivotFields.rowFields.push({ getter: (item) => item[pivotField.key], label: pivotField.label, key: pivotField.key });
			});
			// this.pivotKey++;
		},
	},
};
</script>

<style>
#wdr-tab-apply-fields-type {
	width: 95px !important;
}
</style>
